import React from "react";
import Style from "../../styles/js/StyleEmergency.js";
import redMarker from "../../assets/images/markers/redMarker.png";
import yellowMarker from "../../assets/images/markers/yellowMarker.png";
import blueMarker from "../../assets/images/markers/blueMarker.png";
import { Marker } from 'react-leaflet'
import L from 'leaflet';

const EmergencyMarker = (props: any) => {
  const { state } = props;
  const style = Style();

  // Posibles estados
  const PENDIENTE_RECEPCION = 0;
  const RECEPCIONADO = 1;

  // Devuelve el marcador correspondiente dependiento del estado.
  const getMarker = (state) => {
    if (state === PENDIENTE_RECEPCION) return redMarker;
    else if (state === RECEPCIONADO) return yellowMarker;
    else return blueMarker;
  };

  return (
    <Marker className={style.marker}
      position={[props.lat,props.lng]}
      icon={new L.Icon({ 
        iconUrl: getMarker(state),
        iconSize: [32,45],
        iconAnchor: new L.Point(16, 45),
      })}
      eventHandlers={{
        click: (e) => {
          props.clickcall(props.alert);
        },
      }}
    />
  );
};

export default EmergencyMarker;
